import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';

const AdminLayout = () => {
  const navigate = useNavigate();
  const { admin, logout } = useAdminAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 w-64 bg-gray-800 text-white">
        <div className="p-4">
          <h1 className="text-2xl font-bold">Admin Panel</h1>
          <p className="text-sm text-gray-400 mt-1">
            {admin?.username} ({admin?.role})
          </p>
        </div>
        <nav className="mt-4">
          <Link
            to="/admin/dashboard"
            className="block px-4 py-2 hover:bg-gray-700"
          >
            Tableau de bord
          </Link>
          {admin?.role === 'superAdmin' && (
            <Link
              to="/admin/administrators"
              className="block px-4 py-2 hover:bg-gray-700"
            >
              Gestion des administrateurs
            </Link>
          )}
          <Link
            to="/admin/settings"
            className="block px-4 py-2 hover:bg-gray-700"
          >
            Paramètres
          </Link>
          <button
            onClick={handleLogout}
            className="block w-full text-left px-4 py-2 hover:bg-gray-700 text-red-400"
          >
            Déconnexion
          </button>
        </nav>
      </div>

      {/* Main content */}
      <div className="ml-64 p-4">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout; 